<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店:</label>
          <storeListSelect class="item" v-model="query.storeIdList" @on-change="handleChangeStore"></storeListSelect>
        </div>
        <div class="queryItem">
            <goodsSearchItem labelString="商品" v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>总数量:</label>
          <lk-select class="item" v-model="query.hasTotalNum" clearable>
            <lk-option v-for="(item, index) in hasGoodsList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>可售数量:</label>
          <lk-select class="item" v-model="query.hasGoods" clearable>
            <lk-option v-for="(item, index) in hasGoodsList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>配送在途:</label>
          <lk-select class="item" v-model="query.hasSaleFrozenNum" clearable>
            <lk-option v-for="(item, index) in hasGoodsList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>冻结数量:</label>
          <lk-select class="item" v-model="query.hasFrozenNum" clearable>
            <lk-option v-for="(item, index) in hasGoodsList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>批次:</label>
          <lk-input class="item" v-model.trim="query.goodsBatchSeq" :maxlength="50" placeholder="请输入批次"></lk-input>
        </div>
        <div class="queryItem">
          <label>批号:</label>
          <lk-input class="item" v-model.trim="query.goodsBatchNumber" :maxlength="50" placeholder="请输入批号"></lk-input>
        </div>
        <div class="queryItem">
          <label>入库时间:</label>
          <timeStampDatePicker
            class="item"
            type="date"
            clearable
            placeholder="请选择"
            v-model="query.createTimeMs"
            >
          </timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>生产厂家:</label>
          <lk-input class="item" v-model.trim="query.producer" :maxlength="50" clearable placeholder="生产厂家"></lk-input>
        </div>
        <div class="queryItem">
          <label>供应商:</label>
          <SupplierListSelect v-model="query.supplierStoreIdList" multiple></SupplierListSelect>
        </div>
        <div class="queryItem">
          <label>有效期:</label>
          <timeStampDatePicker
            class="item"
            type="daterange"
            clearable
            placeholder="请选择"
            v-model="query.duration"
            >
          </timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>近效期天数不大于:</label>
          <NumberInput class="item" size='default' v-model.trim="query.beforeExpireDays" :maxlength="50" clearable placeholder="请输入"></NumberInput>
        </div>
        <div class="queryItem">
          <label>仓库:</label>
          <lk-select class="item" v-model="query.warehouseIds" clearable>
            <lk-option v-for="item in warehouseList" :value="item.id" :key="item.id">{{ item.name }}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品标签:</label>
          <lk-select filterable class="item" v-model="query.labelIdList" clearable>
            <lk-option v-for="(item,index) in goodsLabelList" :key="index" :value="item.id">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品状态:</label>
          <lk-select class="item" v-model="query.statusCodeList" clearable>
            <lk-option v-for="(item, index) in goodsStoreStatusList.entries()" :value="item[0]" :key="index">
              {{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>来源:</label>
          <lk-select class="item" v-model="query.purchaseType" clearable>
            <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleFinalSearch(false)">查询</lk-button>
          <lk-button @click="handleReset()">重置</lk-button>
        </div>
      </div>
      <div slot="table" class="mt8">
        <!-- 异步导出Excel Start -->
        <DownloadButton class="mb16" @on-click="download" v-if="handlePermission('inventoryQueryExcel')"></DownloadButton>
        <!-- 异步导出Excel End -->
        <!-- 合计 -->
        <SummaryInfoList
          :roleType='roleType'
          :summaryTitleList='summaryTitleList'
          :summaryInfo='summaryInfo'
        ></SummaryInfoList>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- 冻结和解冻弹出层 开始 -->
    <lk-modal
      v-if="hasInventoryEdit"
      v-model="forzenModal.visiable"
      :mask-closable="false"
      :title="forzenModal.type === 1 ? '冻结' : '解冻'"
      @on-cancel="cancelFrozen"
    >
      <lk-form
        label-position="right"
        :label-width="150"
        :rules="frozenRules"
        :model="frozenModel"
        ref="frozenForm"
      >
        <div class="modalContainer">
          <div v-show="forzenModal.type === 1">
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="当前可冻结数量:" prop="couldSaleNum">
                  <span>{{frozenModel.couldSaleNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="原冻结数量:" prop="manualFrozenNum">
                  <span>{{frozenModel.manualFrozenNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="本次计划新增冻结数量:" prop="newManualFrozenNum" key="1">
                  <lk-input-number
                    style="width: 100%"
                    :min="0"
                    :max="1000000000"
                    :precision="2"
                    :active-change="false"
                    v-model="frozenModel.newManualFrozenNum">
                  </lk-input-number>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
          <div v-show="forzenModal.type === 2">
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="当前冻结数量:" prop="manualFrozenNum">
                  <span>{{frozenModel.manualFrozenNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="可解冻数量:">
                  <span>{{frozenModel.useManualFrozenNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="本次解冻数量:" prop="newManualFrozenNum" key="2">
                  <lk-input-number
                    style="width: 100%"
                    :min="0"
                    :max="999999999.99"
                    :precision="2"
                    :active-change="false"
                    v-model="frozenModel.newManualFrozenNum">
                  </lk-input-number>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelFrozen">取消</lk-button>
          <lk-button type="primary" @click="handleDoManualFreeze" :loading="forzenModal.loading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 冻结和解冻弹出层 结束 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import InventoryInfoExpand from './InventoryInfoExpand.vue';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import goods from '../../services/goods';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';
import Uploader from '../../components/Uploader.vue';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import SummaryInfoList from '../../components/inventory/SummaryInfoList.vue';

export default {
  name: 'inventory',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    InventoryInfoExpand,
    SupplierListSelect,
    SummaryInfoList,
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    hasInventoryEdit() {
      return this.handlePermission('fakeFreeze') && this.handlePermission('fakeUnFreeze');
    },
  },
  data() {
    return {
      summaryInfo: {}, // 总计信息
      summaryTitleList: [ // 总计title列表
        {
          title: '含税总金额',
          key: 'amountWithTax',
        },
        {
          title: '不含税金额',
          key: 'amountWithoutTax',
        },
        {
          title: '配送在途',
          key: 'sumSaleFrozenNum',
        },
        {
          title: '冻结数量',
          key: 'sumFrozenNum',
        },
        {
          title: '可售数量',
          key: 'sumGoodsStockNum',
        },
        {
          title: '总数量',
          key: 'sumTotalNum',
        },
      ],
      goodsStoreStatusList: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      hasGoodsList: new Map().set(1, '有').set(2, '无'),
      goodsLabelList: [],
      query: {
        duration: [],
        beforeExpireDays: null,
        storeIdList: [], // 门店名称
        nameMix: null, // 商品搜索
        producer: null, // 生产企业
        statusCodeList: [], // 商品状态
        supplierStoreIdList: [], // 供应商
        hasGoods: null, // 数量选择，1有 2无，默认为1
        createTimeMs: null, // 入库时间
        warehouseIds: [], // 商品仓库
        labelIdList: [], // 商品标签
        type: null, // 商品类型
        purchaseType: 1, // 来源
        goodsBatchNumber: null, // 批号
        // 新增的四个检索传给后端1，2不再需要boolean类型
        hasFrozenNum: null, // 报损冻结数量
        hasSaleFrozenNum: null, // 配送在途数量
        hasTotalNum: 1, // 总数量
        goodsBatchSeq: null, // 批次
      },
      forzenModal: { // 控制冻结||解冻弹出层
        visiable: false,
        type: '', // 1冻结 2解冻
        loading: false,
      },
      frozenRules: {
        newManualFrozenNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                callback(new Error('请此处为必填项，不能为空'));
              }
              if (this.forzenModal.type === 1) { // 冻结
                if (value === 0) {
                  callback(new Error('数量应大于0'));
                }
                if (value > this.frozenModel.couldSaleNum) {
                  callback(new Error('本次计划新增冻结数量必须小于等于可冻结数量'));
                }
                callback();
              } else {
                if (value > this.frozenModel.manualFrozenNum) {
                  callback(new Error('本次解冻数量必须小于等于当前冻结数量'));
                }
                if (value > this.frozenModel.useManualFrozenNum) {
                  callback(new Error('本次解冻数量必须小于等于当前可解冻数量'));
                }
                callback();
              }
            },
          },
        ],
      },
      frozenModel: {
        id: '', // 当前修改的记录
        couldSaleNum: '', // 当前可售数量
        manualFrozenNum: '', // 冻结库存数量
        newManualFrozenNum: null, // 新值
        useManualFrozenNum: null, //可解冻数量
      },
      maintainTypeList: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      paymentTypeList: new Map([
        [1, '普通'],
        [2, '寄售'],
      ]),
      subColumns: [
        { title: '配送在途数量', key: 'saleOrderDispatchingFrozenNum', minWidth: 60 },
        { title: '电子处方冻结数量', key: 'epSaleFrozenNum', minWidth: 60 },
        { title: '供应商退货冻结数量', key: 'supplierRefundFrozenNum', minWidth: 60 },
        { title: '药品召回冻结数量', key: 'inventoryRecallFrozenNum', minWidth: 60 },
        { title: '盘损冻结数量', key: 'inventoryCheckLoseFrozenNum', minWidth: 60 },
        { title: '库存养护冻结数量', key: 'inventoryCuringFrozenNum', minWidth: 60 },
        { title: '不合格冻结数量', key: 'unqualifiedFrozenNum', minWidth: 60 },
        { title: '手动冻结数量', key: 'manualRecordFrozenNum', minWidth: 60 },
        { title: '可销售数量', key: 'couldSaleNum', minWidth: 60 },
      ],
      columns: [
        {
          type: 'expand',
          minWidth: 50,
          fixed: 'left',
          render: (h, params) => h(InventoryInfoExpand,
            {
              props: {
                row: params.row,
              },
            }),
          // render: (h, params) => h('lk-table', {
          //   props: {
          //     columns: this.subColumns,
          //     data: params.row.inventoryFrozenLists,
          //   }
          // }),
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 85,
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 105,
        },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 140,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 140,
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          minWidth: 140,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 85,
        },
        {
          title: '总数量',
          key: 'totalNum',
          minWidth: 90,
        },
        {
          title: '可售数量',
          key: 'couldSaleNum',
          minWidth: 90,
        },
        {
          title: '配送在途',
          key: 'saleFrozenNum',
          minWidth: 90,
        },
        {
          title: '冻结数量',
          key: 'frozenNum',
          minWidth: 90,
        },
        {
          title: '含税金额',
          key: 'taxInclusiveTotalAmount',
          minWidth: 116,
        },
        {
          title: '不含税金额',
          key: 'taxExclusiveTotalAmount',
          minWidth: 116,
        },
        {
          title: '进项税率',
          key: 'taxRate',
          minWidth: 90,
          render: (h, { row }) => h('span', (`${row.taxRate}%`)),
        },
        {
          title: '税额',
          key: 'taxes',
          minWidth: 116,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 100,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 130,
        },
        {
          title: '供应商',
          key: 'supplierName',
          minWidth: 155,
        },
        {
          title: '生产日期',
          key: 'goodsProductionDate',
          width: 100,
          render: (h, { row }) => h('span', utils.exchangeTime(row.goodsProductionDate)),
        },
        {
          title: '有效期',
          key: 'goodsExpiryDate',
          minWidth: 100,
          render: (h, { row }) => h('span', utils.exchangeTime(row.goodsExpiryDate)),
        },
        {
          title: '近效期天数',
          key: 'nearlyEffectiveDays',
          minWidth: 100,
        },
        {
          title: '入库时间',
          key: 'createTime',
          minWidth: 100,
          render: (h, { row }) => h('span', utils.exchangeTime(row.createTime)),
        },
        {
          title: '最后销售日期',
          key: 'lastSaleDate',
          minWidth: 110,
          render: (h, params) => h('span', utils.exchangeTime(params.row.lastSaleDate)),
        },
        {
          title: '在库天数',
          key: 'inStockDays',
          minWidth: 90,
        },
        {
          title: '不动销天数',
          key: 'unsalableDays',
          minWidth: 95,
        },
        {
          title: '商品进价',
          key: 'priceBeforeTax',
          minWidth: 90,
        },
        {
          title: '零售价格',
          key: 'retailPrice',
          minWidth: 90,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 116,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 166,
          render: (h, { row }) => h('div', [
            this.handlePermission('fakeFreeze') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.couldSaleNum === 0,
              },
              on: {
                click: () => {
                  this.handleFrozenVisiable(row, 1);
                },
              },
            }, '冻结') : null,
            this.handlePermission('fakeUnFreeze') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.manualFrozenNum === 0,
              },
              on: {
                click: () => {
                  this.handleFrozenVisiable(row, 2);
                },
              },
            }, '解冻') : null,
            this.handlePermission('fakeUdi') && [25, 7, 3].indexOf(this.$store.state.storeInfo.id) >= 0 && row.udiFlag === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'fakeUdi',
                    params: {
                      inventoryId: row.id,
                    },
                  });
                },
              },
            }, 'UDI管理') : null,
          ]),
        },
      ],
      tableData: [],
      warehouseList: [],
    };
  },
  methods: {
    getData(isTransform) {
      this.params.page = this.page;
      this.params.size = this.size;
      if (!isTransform) {
        // if (this.params.createTimeMs) {
        //   this.params.createTimeMs = this.params.createTimeMs.getTime();
        // }
        // 后台需要boolean类型数据 1true 2false
        (this.params.hasGoods === 1) && (this.params.hasGoods = true);
        (this.params.hasGoods === 2) && (this.params.hasGoods = false);

        // 后台需要List<Integer>类型数据
        this.params.statusCodeList = [this.params.statusCodeList];
        // this.params.supplierStoreIdList = [this.params.supplierStoreIdList];
        this.params.warehouseIds = [this.params.warehouseIds];
        this.params.labelIdList = [this.params.labelIdList];
      }
      if (this.params.duration.length) {
        this.params.expiryDateStart = this.params.duration[0];
        this.params.expiryDateEnd = this.params.duration[1];
      }
      inventory.getInventoryData(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { count, list } = res.data.data;
          this.count = count;
          list.forEach((item) => {
            const currentItem = item.inventoryInfo;
            currentItem.mah = item.goodsInfoVo && item.goodsInfoVo.mah;
            currentItem.udiFlag = item.inventoryInfo && item.inventoryInfo.udiFlag;
            this.tableData.push(currentItem);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getWarehouseList(storeListIds = []) {
      const warehouseIdList = this.query.warehouseIdList;
      this.query.warehouseIdList = [];
      this.$store.commit('setDisableLoading', true);
      inventory.inventoryNameList({ storeIdList: storeListIds })
        .then((res) => {
          if (res.data.status === 200) {
            this.warehouseList = res.data.data;

            // 先选中了A门店，并且选中了该门店下的a仓库，接着选中了B门店，a仓库正常保留，此时清空A门店，a仓库被清空
            const lastWarehouseIndex = this.warehouseList.findIndex(item => item.id === warehouseIdList);
            if (lastWarehouseIndex !== -1 && storeListIds.length) {
              this.query.warehouseIdList = warehouseIdList;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getGoodsLabel() {
      goods.listGoodsLabels()
        .then((res) => {
          if (res.data.status === 200) {
            this.goodsLabelList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleChangeStore(storeIdList) {
      this.getWarehouseList(storeIdList);
    },
    handleFrozenVisiable(row, type) {
      this.forzenModal.visiable = true;
      this.forzenModal.type = type;
      this.frozenModel.id = row.id;
      this.frozenModel.couldSaleNum = row.couldSaleNum;
      this.frozenModel.manualFrozenNum = row.allFrozenNum;
      this.frozenModel.useManualFrozenNum = row.useManualFrozenNum;
      this.frozenModel.newManualFrozenNum = type === 1 ? row.couldSaleNum : row.useManualFrozenNum;
    },
    // 冻结或者解冻操作
    handleDoManualFreeze() {
      this.$refs.frozenForm.validate((valid) => {
        if (valid) {
          this.$store.commit('setDisableLoading', true);
          const params = {
            id: this.frozenModel.id,
            manualFrozenNum: this.frozenModel.newManualFrozenNum,
            useManualFrozenNum: this.frozenModel.useManualFrozenNum || '',
          };
          const type = this.forzenModal.type;
          const finalFormAction = type === 1 ? inventory.manualFreeze : inventory.manualUnFreeze;
          this.forzenModal.loading = true;
          finalFormAction(params)
            .then((res) => {
              if (res.data.status === 200) {
                this.$Message.success(type === 1 ? '冻结成功' : '解冻成功');
                this.forzenModal.visiable = false;
                this.getData(true);
              } else {
                this.$Message.error(res.data.error);
              }
              this.forzenModal.loading = false;
            })
            .catch((err) => {
              this.forzenModal.loading = false;
              utils.handleError(err);
            });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    cancelFrozen() {
      this.$refs.frozenForm.resetFields();
      this.forzenModal.visiable = false;
    },
    handleReset() {
      this.query = {
        duration: [],
        hasTotalNum: 1,
      };
    },
    download() {
      const params = Object.assign({}, this.params);
      params.page = 0;
      params.size = 0;
      if (params.duration.length) {
        params.expiryDateStart = params.duration[0];
        params.expiryDateEnd = params.duration[1];
      }


      params.queryCondition = utils.getQueryCondition('.queryContainer');
      inventory.inventoryQueryDownload(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInventorySummary() {
      this.summaryInfo = {};
      inventory.getInventorySummary(this.params).then((res) => {
        if (res.data.status === 200) {
          this.summaryInfo = res.data.data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleFinalSearch(flag) {
      this.roleType === 2 ? this.handleSearch(flag, this.getInventorySummary) : this.handleSearch(flag);
    },
  },
  created() {
    this.handleFinalSearch(true);
    this.getGoodsLabel(); // 商品标签
    this.getWarehouseList(); // 商品仓库
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', width: 155 });
    }

    // 没有编辑权限，移除操作列
    if (!this.hasInventoryEdit) {
      this.columns.pop();
    }
  },
};
</script>

<style lang="less" scoped>
  .queryContainer {
    transition: all 1s
  }
  /deep/ .ivu-table-wrapper {
  .ivu-table {
    line-height: 15px !important;
    th {
      height: auto;
      padding: 10px 0;
    }
    td {
      padding: 5px 0;
      height: auto;
    }
    .ivu-table-cell {
      .ivu-btn {
        line-height: 0.6;
      }
    }
    .ivu-table-tip table td {
      height: 40px;
    }
  }
}
</style>
